/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Button_LabelInputs */

const en_confirm_button_label = /** @type {(inputs: Confirm_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const nl_confirm_button_label = /** @type {(inputs: Confirm_Button_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bevestigen`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Confirm_Button_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const confirm_button_label = /** @type {((inputs?: Confirm_Button_LabelInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Button_LabelInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_confirm_button_label(inputs)
	return en_confirm_button_label(inputs)
});